import { useCallback } from "react";

import useRestMutation from "@/remoteState/useRestMutation";

export const PARNASSUS_HOST =
  process.env.NEXT_PUBLIC_PARNASSUS_URL || "/parnassus/api/v2";
const useChallengesGet = () => {
  const createEventRecordRequest = useCallback((params) => {
    const month = params.month;
    const year = params.year;
    const url = `${PARNASSUS_HOST}/challenges/?month=${month}&year=${year}`;
    const requestConfig = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useChallengesGet;
